import { Button } from "components/buttons";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useMemo } from "react";

export function TemplateBuilderYesNoPreview({ question, answer, onChange }) {
  const value = useMemo(() => {
    return answer?.answer;
  }, [answer]);

  //Load default value
  useEffect(() => {
    if (isAnswerValid(value)) {
      return;
    }

    const { defaultValue } = question;
    isAnswerValid(defaultValue) && handleChange(defaultValue);
  }, [value, question]);

  const handleChange = (newValue) => {
    const newAnswer = {
      ...answer,
      $answerType: "YesNo",
      questionId: question.id,
      answer: newValue,
      isAnswered: isAnswerValid(newValue)
    };

    onChange(newAnswer);
  };

  const isAnswerValid = useCallback((newValue) => {
    return [true, false].includes(newValue);
  }, []);

  return <div className="check-preview-form-field">
    <Button
      onClick={() => handleChange(true)}
      text={question?.labelForYes}
      className={`yesNo-selector ${value === true ? 'active' : ''}`}
    />
    <Button
      onClick={() => handleChange(false)}
      text={question?.labelForNo}
      className={`yesNo-selector ${value === false ? 'active' : ''}`}
    />
  </div>
}

TemplateBuilderYesNoPreview.propTypes = {
  answer: PropTypes.object,
  question: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};